import { AsyncPipe, NgFor, NgIf } from '@angular/common';
import { AfterViewInit, Component, ViewChild, ViewContainerRef } from '@angular/core';
import { RouterLink } from '@angular/router';
import { Observable } from 'rxjs';
import { SvgIconComponent } from '../../../../shared/components/svg-icon/svg-icon.component';
import { ConfigRepository } from '../../../../shared/repositories/config.repository';
import { SocialLink } from '../../../../api/v1/models/social-link';
import { SeparateTask } from '../../../../shared/utils/separate-task';
import { AdditionalPageShort } from '../../../../api/v1/models/additional-page-short';
import { FooterHeightDirective } from './footer-height.directive';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    standalone: true,
    imports: [NgIf, RouterLink, NgFor, SvgIconComponent, AsyncPipe, FooterHeightDirective]
})
export class FooterComponent implements AfterViewInit {
  constructor(
    private configRepository: ConfigRepository,
  ) {}

  @ViewChild('metricView', { read: ViewContainerRef }) metricView: ViewContainerRef;

  isIiko$: Observable<boolean | null> =  this.configRepository.isIiko$;
  address$: Observable<string | undefined | null> =  this.configRepository.address$;
  socialLinks$: Observable<SocialLink[] | null> =  this.configRepository.socialLinks$;

  additionalAbout$: Observable<AdditionalPageShort | undefined> =  this.configRepository.additionalAbout$;
  additionalPrivacy$: Observable<AdditionalPageShort | undefined> = this.configRepository.additionalPrivacy$;
  personalDataPolicyPage$: Observable<AdditionalPageShort | null> = this.configRepository.personalDataPolicyPage$;
  fromRussia$: Observable<boolean | null> = this.configRepository.fromRussia$;

  ngAfterViewInit(): void {
    void this.loadMetric();
  }

  @SeparateTask()
  async loadMetric(): Promise<void> {
    this.metricView.clear();
    const {MetricFooterComponent} = await import('../../../../components/metric-footer/metric-footer.component');
    this.metricView.createComponent(MetricFooterComponent);
  }
}

